import RecentClient from "./RecentClient";

export default RecentClient;